import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { isAdminRole, extractUserRole } from '../role.constants';

/**
 * RenterGuard — Hanya izinkan role Renter.
 * Jika user role admin (Owner/Keeper/Administrator) → redirect ke /dashboard.
 * Jika belum login → redirect ke /sign-in.
 */
@Injectable({ providedIn: 'root' })
export class RenterGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        return this.authService.check().pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    return of(this.router.createUrlTree(['/sign-in']));
                }

                const user = this.authService.getCurrentUser();
                const role = extractUserRole(user?.role || user);

                if (!isAdminRole(role)) {
                    // Renter (or any non-admin role) → allowed
                    return of(true);
                }

                // Admin trying to access user routes → redirect to dashboard
                console.warn(`[RenterGuard] Role "${role}" tidak diizinkan akses user routes`);
                return of(this.router.createUrlTree(['/dashboard']));
            })
        );
    }
}
